export const SectionTypes = {
    articleCarousel: 'articleCarousel',
    carousel: 'carousel',
    contentGrid: 'contentGrid',
    homeHeroSection: 'homeHeroSection',
    product: 'product',
    bookServiceCard: 'bookServiceCard',
    textAsset: 'textAsset',
    newsletter: 'newsletter',
    richTextContent: 'richTextContent'
}

export const ContentGridSectionTypes = {
    body: 'Body',
    bookingSection: 'Booking Section',
    careersGrid: 'Careers Grid',
    cardsGrid: 'Cards Grid',
    cardsGridWithLeftTitle: 'Cards Grid with left title',
    cardsTeam: 'Cards Team',
    categoryGrid: 'Category Grid',
    description: 'Description',
    heroCarousel: 'Hero Carousel',
    heroSection: 'Hero Section',
    ingredientGlossary: 'Ingredient Glossary',
    dualSection: 'Dual Section',
    newsletterSection: 'Newsletter Section',
    paragraph: 'Paragraph',
    pinnedSection: 'Pinned Section',
    productCarousel: 'Product Carousel',
    realms: 'Realms',
    videoSection: 'Video Section'
}

export const ContentGridItemTypes = {
    card: 'card',
    richTextContent: 'richTextContent'
}
